export default "__VITE_ASSET__Db6iAn3b__"